import { RootState } from "@/redux/store";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useTemplates = () => {
  const navigate = useNavigate();
    const communityDetail = useSelector(
      (state: RootState) => state.currentData.communityData
    );

    const onCardClick = (link: string) => {
      navigate(link);
    };

    return {
      communityDetail,
      onCardClick
    };
};

export default useTemplates;